// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
    // Newsletter Modal functionality
    const newsletterModal = document.getElementById('newsletter-modal');
    if (newsletterModal) {
      const closeButton = newsletterModal.querySelector('.newsletter-modal__close-button');
      const modalContent = newsletterModal.querySelector('.newsletter-modal__content');
      const modalOverlay = newsletterModal.querySelector('.modal-overlay');
      
      // Function to open the modal
      function openModal() {
        newsletterModal.classList.remove('hidden');
        document.body.classList.add('overflow-hidden');
        
        // If trapFocus function exists (from theme), use it
        if (typeof trapFocus === 'function') {
          trapFocus(modalContent);
        }
      }
      
      // Function to close the modal
      function closeModal() {
        newsletterModal.classList.add('hidden');
        document.body.classList.remove('overflow-hidden');
        
        // If removeTrapFocus function exists (from theme), use it
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus();
        }
      }
      
      // Add event listeners
      if (closeButton) {
        closeButton.addEventListener('click', closeModal);
      }
      
      if (modalOverlay) {
        modalOverlay.addEventListener('click', closeModal);
      }
      
      // Close on escape key
      document.addEventListener('keyup', function(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          closeModal();
        }
      });
      
      // Expose the open function to the global scope
      window.openNewsletterModal = openModal;
    }
    
    // Floating Newsletter Button functionality
    const floatingButton = document.querySelector('.floating-newsletter-button');
    if (floatingButton) {
      const button = floatingButton.querySelector('button');
      
      if (button) {
        button.addEventListener('click', function() {
          if (typeof window.openNewsletterModal === 'function') {
            window.openNewsletterModal();
          }
        });
      }
    }
  });